var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/style.ts
import { css, keyframes } from "@emotion/react";
import { getVar } from "@teamsparta/stack-utils";
var lineColorVar = "--stack-spinner-line-color";
var svgSizeVar = "--stack-spinner-svg-size";
var pathCxVar = "--stack-spinner-path-cx";
var pathCyVar = "--stack-spinner-path-cy";
var pathRVar = "--stack-spinner-path-r";
var strokeWidthVar = "--stack-spinner-stroke-width";
var paddingVar = "--stack-spinner-padding";
var DURATION = 1.4;
var STROKE_DASH_OFFSET = `var(${pathRVar}) * 2 * ${Math.PI}`;
var rotator = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" }
});
var dash = keyframes({
  "0%": {
    strokeDashoffset: `calc(${STROKE_DASH_OFFSET})`,
    transform: "rotate(0deg)"
  },
  "50%": {
    strokeDashoffset: `calc((${STROKE_DASH_OFFSET}) / 4)`,
    transform: "rotate(135deg)"
  },
  "100%": {
    strokeDashoffset: `calc(${STROKE_DASH_OFFSET})`,
    transform: "rotate(360deg)"
  }
});
var spinnerSizeVariants = {
  sm: {
    [svgSizeVar]: "14px",
    [pathCxVar]: "7px",
    [pathCyVar]: "7px",
    [pathRVar]: "6px",
    [strokeWidthVar]: "1.5px",
    [paddingVar]: "1px"
  },
  md: {
    [svgSizeVar]: "18px",
    [pathCxVar]: "9px",
    [pathCyVar]: "9px",
    [pathRVar]: "7.5px",
    [strokeWidthVar]: "1.75px",
    [paddingVar]: "1px"
  },
  lg: {
    [svgSizeVar]: "20px",
    [pathCxVar]: "10px",
    [pathCyVar]: "10px",
    [pathRVar]: "9px",
    [strokeWidthVar]: "2px",
    [paddingVar]: "2px"
  },
  xl: {
    [svgSizeVar]: "34px",
    [pathCxVar]: "17px",
    [pathCyVar]: "17px",
    [pathRVar]: "15px",
    [strokeWidthVar]: "3.5px",
    [paddingVar]: "3px"
  }
};
var spinnerSizeCss = (sizes) => sizes.map(
  ({ breakpoint, size }) => css({
    [`@media screen and (min-width: ${breakpoint}px)`]: __spreadValues({}, spinnerSizeVariants[size])
  })
);
var spinnerCss = css({
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  animation: `${rotator} ${DURATION}s linear infinite`,
  willChange: "transform",
  transform: "translateZ(0)",
  padding: getVar(paddingVar)
});
var spinnerSvgCss = css({
  width: getVar(svgSizeVar),
  height: getVar(svgSizeVar)
});
var pathCss = css({
  strokeDasharray: `calc(${STROKE_DASH_OFFSET})`,
  strokeDashoffset: 0,
  transformOrigin: "center",
  stroke: getVar(lineColorVar),
  strokeWidth: getVar(strokeWidthVar),
  cy: getVar(pathCyVar),
  cx: getVar(pathCxVar),
  r: getVar(pathRVar),
  animation: `${dash} ${DURATION}s ease-in-out infinite`,
  willChange: "stroke-dashoffset, transform",
  transform: "translateZ(0)"
});

export {
  __spreadValues,
  __spreadProps,
  __objRest,
  lineColorVar,
  spinnerSizeVariants,
  spinnerSizeCss,
  spinnerCss,
  spinnerSvgCss,
  pathCss
};
